import { useEffect, useState } from "react";
import { faqs, rules } from "@/mocks/homeContent";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  useEffect(() => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-schema";
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById("faq-schema");
      if (el) el.remove();
    };
  }, []);

  return (
    <section id="rule" className="scroll-mt-16 bg-secondary-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-8">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-heart-2-fill text-primary-500" aria-hidden="true" />
            友善吃瓜守则
          </p>
          <h2 className="mt-3 font-heading text-3xl font-semibold text-foreground-950 md:text-4xl">
            吃得热闹，更要吃得安心
          </h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600 md:text-base">
            在这里，“瓜”是校园生活里的趣事与共鸣。四条底线，我们和你一起守住。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-6 lg:grid-cols-[1fr_1.15fr]">
          <div className="grid grid-cols-1 content-start gap-4 sm:grid-cols-2 lg:grid-cols-1">
            {rules.map((r) => (
              <div
                key={r.title}
                className="flex gap-4 rounded-2xl border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-2xl">
                  {r.emoji}
                </span>
                <div>
                  <p className="font-heading text-base font-semibold text-foreground-950">
                    {r.title}
                  </p>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{r.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="rounded-3xl border border-background-200 bg-background-50 p-6 md:p-8">
            <h3 className="font-heading text-xl font-semibold text-foreground-950">
              投稿与平台常见问题
            </h3>
            <p className="mt-1 text-sm text-foreground-600">
              关于匿名、审核与边界，你担心的我们提前想好了。
            </p>

            <div className="mt-5 divide-y divide-background-200">
              {faqs.map((f, i) => {
                const open = openIndex === i;
                return (
                  <div key={f.q} className="py-1">
                    <button
                      type="button"
                      aria-expanded={open}
                      onClick={() => setOpenIndex(open ? null : i)}
                      className="flex w-full items-start justify-between gap-4 py-3 text-left"
                    >
                      <span className="text-sm font-medium text-foreground-900 md:text-base">
                        {f.q}
                      </span>
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-foreground-700">
                        <i
                          className={open ? "ri-subtract-line" : "ri-add-line"}
                          aria-hidden="true"
                        />
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${
                        open ? "grid-rows-[1fr] pb-4 opacity-100" : "grid-rows-[0fr] opacity-0"
                      }`}
                    >
                      <div className="overflow-hidden text-sm leading-relaxed text-foreground-600">
                        {f.a}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}